module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_minus-f2065ed94d0d7aad389741e2fcea813e.svg";